const LOGO_URL =
  'https://cdn.thinkific.com/9/20190815/07ef0194bb99558a029d4988882c3fc4.png';

export default LOGO_URL;
